const WORKFORCE_PROFILE_IN_PROGRESS_STATUSES = new Set(['pending', 'processing', 'anonymizing']);

export const isWorkforceProfileAnalysisInProgress = (status: string | null | undefined): boolean => {
  if (!status) {
    return false;
  }

  return WORKFORCE_PROFILE_IN_PROGRESS_STATUSES.has(status);
};
